<template>
  <div class="rhlistDrawer">
    <Drawer
      class="common-drawer"
      :title="title"
      v-model="showInDrawer"
      :mask-closable="false"
      :width="dologwidth"
      @on-close="drwcloseDrawer"
      :scrollable="true"
    >
      <Form
        ref="formValidate"
        :rules="ruleValidate"
        :model="formData"
        label-position="top"
      >
        <Row :gutter="16">
          <Col span="24" class="u-rel">
            <div class="listpw">
              <Tooltip
                theme="light"
                content="支持中文、英文字母、数字和下划线（_），长度限制为 4 ~ 64 个字符，中文算 2 个字符"
                max-width="320"
                :transfer="true"
                placement="right"
                trigger="hover"
              >
                <img
                  src="@/assets/images/wh.png"
                  style="
                    width: 12px;
                    height: 12px;
                    position: relative;
                    top: 1px;
                  "
                  alt=""
                />
              </Tooltip>
            </div>
            <FormItem label="润滑点名称" prop="name">
              <Input
                v-model="formData.name"
                name="drawname"
                placeholder="请输入"
                minlength="4"
                maxlength="64"
              />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="润滑点编号" prop="oilSiteIotName">
              <Input
                disabled
                v-model="formData.oilSiteIotName"
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="产品名称（物联网）">
              <Input
                :disabled="this.iszhuangzhiId"
                v-model="formData.iotProductName"
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="DeviceName （物联网）">
              <Input
                :disabled="this.iszhuangzhiId"
                v-model="formData.iotDeviceName"
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="监测装置型号" prop="zhuangzhiId">
              <Row>
                <Col :span="21">
                  <Select
                    id="zhuangzhiId"
                    disabled
                    v-model="formData.zhuangzhiId"
                    placeholder="请选择"
                  >
                    <Option
                      :key="type.id"
                      :value="type.id"
                      v-for="type in cityList"
                      >{{ type.name }}
                    </Option>
                  </Select>
                </Col>
                <Col :span="3">
                  <div
                    type="text"
                    id="deveemit"
                    @click="devcidUpdate(formData)"
                    class="lan u-text-center"
                  >
                    编辑
                  </div>
                </Col>
              </Row>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="应用类型" prop="application">
              <Select
                ref="applicationtrue"
                :clearable="applicationtrue"
                v-model="formData.application"
                id="mo-application"
                placeholder="请选择"
              >
                <Option
                  :key="key"
                  :value="appitem"
                  v-for="(appitem, key) in applications"
                  >{{ appitem }}
                </Option>
              </Select>
            </FormItem>
          </Col>

          <Col span="24" v-if="!userRole.includes('c')">
            <FormItem label="所属客户" prop="tenantId">
              <Select
                id="mo-tenantId"
                ref="tenantIdtrue"
                :clearable="tenantIdtrue"
                v-model="formData.tenantId"
                @on-change="selTenant"
                placeholder="请选择"
              >
                <Option :key="type.id" :value="type.id" v-for="type in list"
                  >{{ type.value }}
                </Option>
              </Select>
            </FormItem>
          </Col>
          <!-- {{formData.tenantId}} -->
          <Col span="24" v-if="!!formData.tenantId">
            <FormItem label="所属设备" prop="deviceId">
              <Select
                id="mo-deviceId"
                @on-change="pructmeth"
                v-model="formData.deviceId"
                :loading="deviceLoading"
                loading-text="加载中..."
                placeholder="请选择"
              >
                <Option
                  :key="type.id"
                  :value="type.id"
                  v-for="type in deviceList"
                  >{{ type.value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="油箱容量（L）">
              <Input
                v-model="formData.volume"
                type="number"
                step="0.1"
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="润滑油油品" prop="oilProductId">
              <Select
                id="mo-oilProductId"
                v-model="formData.oilProductId"
                placeholder="全部"
                :clearable="oilProductIdtrue"
                ref="oilProductId"
              >
                <Option
                  :key="type.id"
                  :value="type.id"
                  v-for="type in dataCenter.oilProduct"
                  >{{ type.value }}
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="换油周期">
              <Input
                v-model="formData.oilingFatLiquoringPeriod"
                type="number"
                step="0.1"
                placeholder="请输入"
                style="width: 58%"
              />
              <Select
                v-model="formData.unit"
                :clearable="true"
                placeholder="请选择单位"
                ref="unitRef"
                style="width: 39%; margin-left: 10px"
              >
                <Option value="小时">小时</Option>
                <Option value="天">天</Option>
                <Option value="月">月</Option>
                <Option value="年">年</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="关联设备组件" v-if="formData.tenantId">
              <Select
                v-model="formData.graphDeviceComponentId"
                loading-text="加载中..."
                placeholder="无"
                label="无"
              >
                <Option
                  :key="typevalue.deviceComponentVertexId"
                  :value="typevalue.deviceComponentVertexId"
                  v-for="typevalue in devcommentoption"
                  >{{ typevalue.continousNameString }}</Option
                >
              </Select>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="备注">
              <Input
                type="textarea"
                maxlength="32"
                show-word-limit
                v-model="formData.remake"
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="上传图片">
              <Cupload
                v-model="formData.imagesFullPath"
                @change="imagechange"
                :limit="1"
              />
              <!-- <div class="rhWrapUpload">
                <div class="imgWrap">
                  <div class="imgs" v-if="formData.imagesFullPath">
                    <img
                      class="anchorPoint-oilSite-img-edit"
                      :src="formData.imagesFullPath"
                      alt=""
                    />
                    <Icon
                      class="anchorPoint-oilSite-img-del"
                      type="md-close-circle"
                      @click="delImg()"
                    />
                  </div>
                  <div v-else>
                    <img
                      src="../../../assets/images/upload.png"
                      style="cursor: pointer; width: 150px; height: 150px"
                    />
                    <input
                      @change="uploadFunc"
                      type="file"
                      name="file"
                      accept="image/*"
                      id="upFilePic"
                      class="up-files"
                    />
                  </div>
                </div>
                <p class="tip"> 格式：JPG、PNG或JPEG；推荐尺寸：600*600像素；大小：5MB内</p>
              </div>
              <div class="percentWrap" v-if="imgPercent">
                <p class="name">
                  <Icon type="ios-image-outline" /> {{ fileName }}
                </p>
                <Progress
                  :stroke-width="4"
                  :status="upStatus"
                  :percent="imgPercent"
                />
              </div> -->
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div class="drawer-footer">
        <Button
          class="anchorPoint-oilSite-edit-button"
          type="primary"
          id="btn-list-sucess"
          @click="submitForm('formValidate')"
          :loading="btnLoading"
          >提交</Button
        >
        <Button style="margin-left: 8px" @click="drwcloseDrawer">取消</Button>
      </div>
      <!-- <emitDeice
        :cityList="cityList"
        :ficonoption="ficonoption"
        @emitDevid="DevMthods"
        :id="formData.zhuangzhiId"
        :oilSiteId="formData.id"
        v-model="devceShow"
      /> -->
      <div class="rh-model" v-if="timbo" @click="modelmehods"></div>
    </Drawer>
  </div>
</template>

<script>
import api from "@/api";
import ls from "store2";
import deepcopy from "deepcopy";
import { mapState } from "vuex";
import { deviceComponent } from "@/api/oldindex.js";
import { ocmselect, getNewCode } from "@/api/business/rhlist.js";
import { olitypelist, getidFiconPage } from "@/api/knowledge/device.js";
import emitDeice from "./emit-deice.vue";
import debounce from "@/util/debounce";
import Cupload from "@/components/Cupload/index.vue";
import { validateActive } from "@/util/validate";

export default {
  name: "rhlist-drawer",
  components: { emitDeice, Cupload },
  props: {
    showDrawer: Boolean,
    closeDrawer: Function,
    dataCenter: Object,
    getLists: Function,
    curItemDetail: Object,
    cityList: {},
    timernum: {}, //多少秒自动关闭
  },
  data() {
    const validatePassCheck = (rule, value, callback) => {
      try {
        if (!value) {
          callback(new Error("请填写润滑点名称"));
        }
        const cvalue1 = value.replace(/[\u4e00-\u9fa5]/g, "aa")
        console.log('cvalue1',cvalue1)
        const length = value.replace(/[\u4e00-\u9fa5]/g, "aa").length; // 将中文字符替换成两个字母，计算长度
      
        // const regex = /^[\u4e00-\u9fa5\w]{4,64}$/; // 匹配中文、英文字母、数字和下划线，长度为 4 ~ 64 个字符
        // console.log('length',length<4,!regex.test(value,length > 64))
        if(length<4){
          callback(new Error("请输入符合规定名称"));
        }else if(length > 64){
          callback(new Error("请输入符合规定名称"));
        }else if(validateActive(cvalue1)){
          callback(new Error("请输入符合规定名称"));
        }else{
          callback();
        }
     // if ((!(regex.test(value)) || (length < 4) ||(length > 64))) {
      //   callback(new Error("请输入符合规定名称"));
      // } else {
      //   callback();
      // }
       } catch (error) {
          console.log("error",error)
      }
    };
    return {
      oilProductIdtrue: false,
      applicationtrue: false,
      tenantIdtrue: false,
      list: [],
      userRole: ls.get("userRole"),
      ficonoption: [],
      devceShow: false,
      title: "编辑润滑点",
      showInDrawer: false,
      btnLoading: false,
      uploadLoading: false,
      deviceLoading: false,
      imgPercent: 0,
      percentInterval: null,
      upStatus: "active",
      formData: {
        name: null,
        oilSiteTypeId: null,
        oilSiteIotName: null,
        tenantId: null,
        deviceId: null,
        oilProductId: null,
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: "请填写润滑点名称",
            trigger: "blur,change",
          },
          {
            validator: validatePassCheck,
            trigger: "change",
            message: '请输入符合规定名称',
          },
          {
            validator: validatePassCheck,
            trigger: "blur",
            message: '请输入符合规定名称',
          },
        ],
        oilSiteTypeId: [
          {
            required: true,
            message: "请选择润滑点",
            trigger: "change",
          },
        ],
        oilSiteIotName: [
          {
            required: true,
            message: "请填写润滑点编号",
            trigger: "blur,change",
          },
        ],
        tenantId: [
          {
            required: true,
            message: "请选择所属客户",
            trigger: "change",
          },
        ],
        deviceId: [
          // {
          //   required: true,
          //   message: "请选择所属设备",
          //   trigger: "blur,change",
          // },
          {
            required: true,

            trigger: "blur,change",
            validator: (rule, value, callback) => {
              let deviceId = this.formData.deviceId;

              if (deviceId) {
                callback();
              } else {
                callback(new Error("请选择所属设备"));
              }
            },
          },
        ],
        oilProductId: [
          {
            required: true,
            message: "请选择润滑油油品",
            trigger: "blur,change",
          },
        ],
        zhuangzhiId: [
          {
            required: true,
            message: "请选择监测装置型号",
            trigger: "blur,change",
            validator: (rule, value, callback) => {
              let zhuangzhiId = this.formData.zhuangzhiId;

              if (zhuangzhiId) {
                callback();
              } else {
                callback(new Error("请选择监测装置型号"));
              }
            },
          },
        ],
        application: [
          {
            required: true,
            message: "请选择应用类型",
            trigger: "blur,change",
          },
        ],
      },
      deviceList: [],
      devcommentoption: [],
      typeoption: [],
      applications: ["齿轮系统", "液压系统", "循环系统"],
      // ,"轴承系统","压缩机"
      iszhuangzhiId: false,
      tttimer: null,
      timbo: false, // false是可以编辑的  true是编辑不了的
    };
  },
  computed: {
    ...mapState({
      dologwidth: (state) => state.dologwidth,
    }),
  },
  mounted() {
    this.init();
  },
  methods: {
    cleartRest() {
      let t = setTimeout(() => {
        console.log("我清空了");
        this.applicationtrue = true;
        this.tenantIdtrue = true;
        this.oilProductIdtrue = true;
        this.$nextTick(async () => {
          this.$refs["applicationtrue"].clearSingleSelect();
          this.$refs["tenantIdtrue"].clearSingleSelect();
          this.$refs["oilProductId"].clearSingleSelect();
          this.$refs["unitRef"].clearSingleSelect();
          let t1 = setTimeout(() => {
            this.applicationtrue = false;
            this.tenantIdtrue = false;
            this.oilProductIdtrue = false;
            clearTimeout(t1);
          }, 100);
          clearTimeout(t);
        });
      }, 300);
    },
    modelmehods() {
      this.$Modal.info({
        title: "提示",
        content: "页面编辑超时，请重新打开",
        onOk: () => {
          this.drwcloseDrawer();
        },
      });
    },
    drwcloseDrawer() {
      clearTimeout(this.tttimer);
      this.tttimer = null;
      this.closeDrawer();
      this.$nextTick(async () => {
        await this.$c.sleep(300);
        this.$refs.formValidate.resetFields();
        this.cleartRest();
      });
    },
    setregulartimer() {
      clearTimeout(this.tttimer);
      this.tttimer = null;
      this.tttimer = setTimeout(() => {
        this.timbo = true;
        clearTimeout(this.tttimer);
      }, this.timernum);
    },
    devidOK(row) {
      let zhuangzhiId = "";
      if (row.zhuangzhiId) {
        zhuangzhiId = row.zhuangzhiId;
      }
      setTimeout(() => {
        this.$Modal.confirm({
          render: (h) => {
            return [
              h(
                "div",
                {
                  class: "dev-mo-config",
                  attrs: {
                    id: "dev-mo-config",
                  },
                },
                [
                  h(
                    "div",
                    {
                      class: "dev-title",
                    },
                    "编辑润滑点装置"
                  ),
                  [
                    h(
                      "div",
                      {
                        class: "u-flex",
                        style: {
                          position: "relative",
                          top: "6px",
                        },
                      },
                      [
                        h(
                          "div",
                          {
                            attrs: {
                              id: "dev-mo-copacity",
                            },
                            class: "dev-normal",
                            style: {
                              position: "absolute",
                              top: "-53px",
                              opacity: "0",
                            },
                            on: {
                              click: () => {
                               
                                this.$nextTick(() => {
                                  setTimeout(() => {
                                    this.checdetermine(zhuangzhiId);
                                    this.$Modal.remove();
                                  }, 300);
                                });
                              },
                            },
                          },
                          "1"
                        ),
                        h(
                          "div",
                          {
                            class: "dev-normal",
                          },
                          "装置型号"
                        ),
                        h(
                          "div",
                          {
                            style: {
                              width: "90%",
                            },
                          },
                          [
                            h(
                              "Select",
                              {
                                attrs: {
                                  id: "dev-select",
                                },
                                style: {
                                  with: "90%",
                                },
                                props: {
                                  value: zhuangzhiId,
                                },
                                on: {
                                  "on-change": (event) => {
                                    zhuangzhiId = event;
                                  },
                                },
                              },
                              this.cityList.map((item) => {
                                return h(
                                  "Option",
                                  {
                                    props: {
                                      value: item.id,
                                    },
                                  },
                                  item.name
                                );
                              })
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                ]
              ),
            ];
          },
          onOk: (row) => {
            this.$nextTick(() => {
              setTimeout(() => {
                this.checdetermine(zhuangzhiId);
              }, 300);
            });
          },
        });
      }, 300);
    },
    checdetermine(zhuangzhiId) {
      if (this.curItemDetail.id) {
        // this.$Modal.confirm({
        //   title: "提示",
        //   content: "该润滑点的指标发生了变化，请谨慎操作",
        //   onOk: () => {
        //     this.formData.zhuangzhiId = zhuangzhiId;
        //   },
        // });
         this.formData.zhuangzhiId = zhuangzhiId;
      } else {
        this.formData.zhuangzhiId = zhuangzhiId;
      }
      this.$forceUpdate();
    },
    devcidUpdate(row) {
      if (this.curItemDetail.id) {
        let content = "切换装置型号可能会导致指标变化，请谨慎操作";

        if (this.iszhuangzhiId) {
          content = "因为切换装置型号可能会改变指标，必须解绑网关以后才能操作";
        }
        this.$Modal.warning({
          title: "提示",
          content: content,
          onOk: () => {
            this.$nextTick(() => {
              if (!this.iszhuangzhiId) {
                this.devidOK(row);
              }
            });
          },
        });
      } else {
        this.devidOK(row);
      }
    },
    async getcoode() {
      let { data } = await getNewCode();

      return data;
    },
    async init() {
      let { data } = await getidFiconPage({
        current: 1,
        size: 99,
      });

      this.ficonoption = data;
    },
    DevMthods(data) {},
    deviceDeploy() {
      this.devceShow = true;
    },
    handleTabKeyDown(value) {
      const currentField = this.$refs.formValidate.fields.find(
        (field) => field.prop === value
      );

      if (currentField && !currentField.validate()) {
        event.preventDefault(); // 阻止默认的 Tab 切换行为
      }
    },

    async pructmeth(id) {
      let { data } = await deviceComponent(id);

      if (data) {
        this.devcommentoption = data.map((index, key) => {
          index.continousNameString = index.continousName.join("-");
          return index;
        });
      }
    },
    submitForm(name) {
      if (this.formData.oilingFatLiquoringPeriod && !this.formData.unit)
        return this.$Message.success("请选择周期单位");
      this.$refs[name].validate((valid) => {
        if (valid) {
          let formDataCopy = deepcopy(this.formData);

          if (formDataCopy.id) {
            formDataCopy.oilSiteTypeName = undefined;
            formDataCopy.oilSiteTypeCode = undefined;
            formDataCopy.oilSiteTypeStatus = undefined;
            formDataCopy.oilProductName = undefined;
            formDataCopy.oilBrandId = undefined;
            formDataCopy.oilBrandName = undefined;
            formDataCopy.transducers = undefined;
            formDataCopy.consumerName = undefined;
            formDataCopy.workshopId = undefined;
            formDataCopy.workshopName = undefined;
            formDataCopy.deviceName = undefined;
            formDataCopy.deviceTypeId = undefined;
            formDataCopy.deviceTypeName = undefined;
            formDataCopy.imagesFullPath = undefined;
            formDataCopy.monthlyAlarmCount = undefined;
            formDataCopy.oilSiteLabelList = undefined;
            formDataCopy.homeOrder = undefined;
            formDataCopy.alarmRecord = undefined;
            formDataCopy.alarmCount = undefined;
            formDataCopy.alarmUpdateTime = undefined;
            formDataCopy._index = undefined;
            formDataCopy._rowKey = undefined;
            formDataCopy.oilSiteModelVOList = undefined;
            formDataCopy.gmtCreate = undefined;
          }

          // formDataCopy.imagesFullPath = this.formData.key
          this.btnLoading = true;
          let url = formDataCopy.id
            ? "/ocm-oil-site/oil-site/edit"
            : "/ocm-oil-site/oil-site/insert";
          api
            .axss("post", url, formDataCopy)
            .then((res) => {
              if (res.code === "00000") {
                this.$Message.success("提交成功");
                this.drwcloseDrawer(); // 关闭弹窗
                this.getLists(); // 刷新列表
              } else {
                this.$Message.error(res.msg);
              }
              this.btnLoading = false;
            })
            .catch((error) => {
              this.btnLoading = false;
            });
        }
      });
    },
    imagechange(e) {
      const { key } = e;
      this.formData.images = key;
    },
    uploadFunc() {
      let len = document.getElementById("upFilePic").files.length;
      if (len == 0) return;
      var myfile = document.getElementById("upFilePic").files[0];

      const allowedImageTypes = ["image/jpg", "image/png", "image/jpeg"];

      if (!allowedImageTypes.includes(myfile.type)) {
        this.$Message.info(
          "  文件格式错误，请上传JPG、PNG或者JPEG格式的图片文件"
        );
        return;
      }
      this.upStatus = "active";
      var myfile = document.getElementById("upFilePic").files[0];
      this.fileName = myfile.name;
      let fileSize = myfile.size;
      // if(myfile) this.uploadLoading = true

      //限制图片5MB以内
      if (fileSize > 1024 * 1024 * 5)
        return this.$Message.info("上传图片不能大于5MB");

      var oMyForm = new FormData();
      oMyForm.append("file", myfile);
      this.loadPercent();

      api.asxUpFile("post", "/ocm-admin/file/upload", oMyForm).then((res) => {
        try {
          if (res.code === "00000") {
            this.formData.images = res.data.key;
            this.formData.imagesFullPath = res.data.url;
            this.$Message.success("上传成功");
            this.imgPercent = 100;
          } else {
            this.upStatus = "wrong";
          }
        } catch (error) {
          this.upStatus = "wrong";
          this.imgPercent = 0;
        }

        // this.uploadLoading = false
        // 清除percent定时
        window.clearInterval(this.percentInterval);
      });
    },
    loadPercent() {
      this.imgPercent = 0;
      this.percentInterval = setInterval(() => {
        if (this.imgPercent > 95) {
          this.imgPercent = 99;
        } else if (this.imgPercent > 50) {
          this.imgPercent += 3;
        } else {
          this.imgPercent += 18;
        }
      }, 100);
    },
    async selTenant(id, index = 0) {
      this.deviceLoading = true;
      const datas = {
        size: 200,
        type: "device",
        value: "",
        gangedValueMap: {
          tenantId: id,
        },
      };
      let res = await ocmselect(datas);
      if (res.code === "00000") {
        const lists = res.data.records;

        this.deviceList = lists;
        if (!lists.length) this.formData.deviceId = null;
      }
      if (index == 0) {
        this.formData.graphDeviceComponentId = null;
      }

      this.deviceLoading = false;
    },
    delImg() {
      this.formData.images = "";
      this.formData.imagesFullPath = "";
      this.$forceUpdate();
    },
    setzhuangName(id) {
      let item = this.cityList.find((e) => e.id == id);
      return item.name;
    },
  },
  watch: {
    curItemDetail: {
      handler: async function (newValue, oldValue) {
        this.imgPercent = 0;
        if (newValue !== oldValue) {
          this.$refs.formValidate.resetFields();
        }

        if (newValue.id) {
          this.title = "编辑润滑点";
          let cnewValue = this.$c.deepClone(newValue);
          // let name = this.setzhuangName(newValue.zhuangzhiId);
          // cnewValue.devidname = name;

          let formData = this.$c.deepClone(cnewValue);

          this.formData = formData;
          this.pructmeth(this.formData.deviceId); //所属设备

          this.selTenant(newValue.tenantId, 1);
          if (this.formData.gatewayId) {
            this.iszhuangzhiId = true;
          } else {
            this.iszhuangzhiId = false;
          }
        } else {
          //  name
          this.iszhuangzhiId = false;
          this.title = "新增润滑点";
          let data = await this.getcoode();

          this.formData = {
            // deviceId:5+
            name: "",
            oilSiteIotName: data,
          };
        }

        this.$nextTick(() => {
          var modal = document.getElementsByClassName("ivu-form")[0];
          modal.scrollTop = 0;
          if (this.userRole.includes("c")) {
            this.formData.tenantId = this.list[0].id;

            this.selTenant(this.formData.tenantId);
            this.$forceUpdate();
          }
        });
      },
      deep: true,
    },
    showDrawer: {
      handler: function (newValue, oldValue) {
        if (newValue) {
          this.timbo = false;
          if (this.formData.id) {
            this.setregulartimer();
          }
          if (this.userRole == "m0") {
            this.list = this.dataCenter.consumer.filter((e) => {
              if (e.groupAuthorityString == "rw") {
                return true;
              }
            });
          } else {
            this.list = this.dataCenter.consumer;
          }
        } else {
        }
        this.showInDrawer = newValue;
      },
      deep: true,
    },
  },
};
</script>

<style lang='less' scoped>
.rhlistDrawer {
}
</style>
<style lang="less">
.rhWrapUpload {
  .imgWrap {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;

    .imgs {
      position: relative;
      width: 150px;
      height: 150px;
      text-align: center;
      // border: 1px solid #f2f2f2;
      overflow: hidden;

      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }

      .ivu-icon {
        position: absolute;
        font-size: 24px;
        z-index: 2;
        top: 0px;
        right: 0px;
        cursor: pointer;
      }
    }

    .addImg {
      position: relative;
      width: 150px;
      height: 150px;
      text-align: center;
      border: 1px dashed #dcdee2;
      cursor: pointer;

      .ivu-icon {
        color: #dcdee2;
        font-size: 30px;
        margin-top: 30px;
      }

      .up_label {
        width: 150px;
        height: 150px;
        cursor: pointer;

        input {
          width: 1%;
          height: 1%;
          font-size: 0;
        }
      }
    }
  }

  .tip {
    padding: 10px 0;
    color: #aaa;
  }
}

.percentWrap {
  position: relative;

  .name {
    position: absolute;
    top: -12px;
    font-size: 12px;
    color: #666;

    .ivu-icon {
      font-size: 14px;
    }
  }

  .ivu-progress-success .ivu-progress-text {
    color: #19be6b;
    vertical-align: bottom;
  }

  .ivu-progress-wrong .ivu-progress-text {
    color: #ed4014;
    vertical-align: bottom;
  }
}

.up-files {
  position: absolute;
  left: 0;
  opacity: 0;
  width: 150px;
  height: 150px;
  font-size: 0;
  cursor: pointer;
}

.listpw {
  position: absolute;
  left: 96px;
  top: -4px;
}
.dev-title {
  font-size: 16px;
  color: #17233d;
  font-weight: 500;
  position: relative;
  top: -6px;
}
.dev-normal {
  white-space: nowrap;
  margin-right: 10px;
}
</style>